import React, { useState } from "react";
import { CFormGroup, CInput, CLabel } from "@coreui/react";
import { FaCheck, FaPen } from "react-icons/fa";

const SimpleInput = ({
  id = "",
  title = "",
  placeholder = "",
  value = "",
  type = "text",
  className = "",
  onChange = () => {},
  onBlur = () => {},
  onFocus = () => {},
  error,
  required = false,
  disabled = false,
  sideText,
  isEditable = true,
  minTime,
  maxTime,
  style = {},
  isViewAble = true,
  showEditIcon = false,
  newTitleValue = "",
  onChangeTitle,
}) => {
  const [isTitleEditable, setIsTitleEditable] = useState(false);
  return (
    <>
      {isTitleEditable ? (
        <div className="d-flex align-items-center gap-4">
          <CInput
            id={id}
            type="text"
            className={className}
            placeholder="Enter New Heading"
            onChange={onChangeTitle}
            onBlur={onBlur}
            onFocus={onFocus}
            value={newTitleValue}
            style={{
              borderColor: error ? "#e55353" : "",
              paddingBlock: 25,
              marginBottom: 14,
              ...style,
            }}
            disabled={disabled}
          />
          <div
            role="button"
            onClick={() => setIsTitleEditable(false)}
            className="mb-3"
          >
            <FaCheck color="green" size={30} />
          </div>
        </div>
      ) : showEditIcon ? (
        <CLabel htmlFor={id} className="d-flex align-items-center gap-3">
          <span>{newTitleValue || title}</span>
          {required ? <span style={{ color: "red" }}> *</span> : null}
          <div role="button" onClick={() => setIsTitleEditable(true)}>
            <FaPen />
          </div>
        </CLabel>
      ) : (
        (newTitleValue || title) &&
        isViewAble && (
          <CLabel htmlFor={id}>
            {newTitleValue || title}
            {required ? <span style={{ color: "red" }}> *</span> : null}
          </CLabel>
        )
      )}

      {isEditable ? (
        <CInput
          id={id}
          type={type}
          className={className}
          placeholder={placeholder}
          onChange={onChange}
          onBlur={onBlur}
          onFocus={onFocus}
          value={value}
          min={minTime}
          max={maxTime}
          {...(maxTime || minTime ? required : null)}
          style={{
            borderColor: error ? "#e55353" : "",
            paddingBlock: 25,
            ...style,
          }}
          disabled={disabled}
        />
      ) : (
        isViewAble && (
          <div style={{ fontSize: 16.5, fontWeight: 500 }}>{value || "-"}</div>
        )
      )}

      {error ? (
        <CLabel htmlFor={id} style={{ color: "#e55353", marginBottom: 0 }}>
          {error}
        </CLabel>
      ) : null}
    </>
  );
};

export default SimpleInput;
